export const JobType = Object.freeze({
  SHIFT: 'shift',
  INTERVIEW: 'interview',
});
